import clsx from 'clsx';
import { FC } from 'react';

import Icon from 'molecules/Icon';
import Image from 'molecules/Image';
import RichText from 'molecules/RichText';

import { QuoteCardConfigProps } from 'organisms/Cards/Quote/config';
import { quoteContainer } from 'organisms/Cards/Quote/styles';

const QuoteCard: FC<QuoteCardConfigProps> = ({ quote, companyLogo, author, color }) => {
  const safeColor = color === 'green' ? color : 'green';

  return (
    <div className={quoteContainer({ color: safeColor })}>
      {companyLogo?.file?.url && (
        <Image
          url={companyLogo.file.url}
          alt={companyLogo?.alt || 'company'}
          width={companyLogo.file.width}
          height={companyLogo.file.height}
          className="h-9 w-auto"
        />
      )}
      <Icon icon="block-quote" size={44} iconColor="text-primary-1000" />
      {quote && <RichText text={quote} className={clsx('flex items-start justify-start text-left text-gray-900')} />}
      <div className="flex flex-row gap-3 sm:gap-6">
        {author && (
          <>
            {author.headshot?.file?.url && (
              <Image
                url={author.headshot.file.url}
                alt={author.headshot?.alt || 'headshot'}
                width={author.headshot.file.width}
                height={author.headshot.file.height}
                className="h-16 w-auto"
              />
            )}
            <div className="flex flex-col justify-start gap-2">
              <div className={clsx('text-xl font-bold text-gray-900 sm:text-display-xs')}>{author?.name}</div>

              <div className={clsx('text-md font-medium text-gray-700 sm:text-lg')}>{author?.title}</div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default QuoteCard;
